import $http from "../../axios";
import { Notification } from "element-ui";

export async function searchProductsWms ({ state, commit }) {
    const params = {
        product_id: state.dataProductsWms.product_id,
        ...state.params
    };

    await $http.get("/api/consult-product-lot", {params: params})
        .then(response => {
            commit("setAvailabilityWmsProducts", response.data.data);
        }).catch(error => {
            throw new Error(error.response.data.message); // Propaga el error para que pueda ser manejado en el componente
        });
}



// WEBPACK FOOTER //
// ./src/modules/modal-list-product-wms/actions.js